import React from 'react';
import { Box, Grid, Paper, Tab, Tabs } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import PageHeader from '../../../components/page-header';
import { FormPageFooter } from '../../../components/form-page-parts';
import ContractFileDataTable from './components/contract-file-data-table';
import { ContractIdentificationSection } from './components/contract-identification-section';
import { ContractSupplierSection } from './components/contract-supplier-section';
import { ContractValuesSection } from './components/contract-values-section';
import { useContractCreateEditState } from './context/contract-create-edit-context';
import { useContractCreateEditController } from './context/contract-create-edit-controller';
import { validateContract } from './context/contract-validation';

const TAB_GENERAL = 0;
const TAB_FILES = 1;

export function CreateEditContractComponent() {
    const ctrl = useContractCreateEditController();
    const { contractId, contractRequest, tabIndex, showValidationErrors, file } = useContractCreateEditState();
    const errors = showValidationErrors ? validateContract(contractRequest, { isEdit: ctrl.isEdit, hasFile: !!file }) : {};

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title={ctrl.isEdit ? 'Editar Contrato' : 'Novo Contrato'}
                    subtitle={ctrl.isEdit ? 'Atualize as informações do contrato' : 'Cadastre um novo contrato'}
                    breadcrumbs={[
                        { label: 'Contratos', href: '/contratos' },
                        { label: ctrl.isEdit ? 'Editar' : 'Novo' },
                    ]}
                />
            </Grid>

            <Grid item xs={12}>
                <Paper sx={{ p: 3, display: 'flex', flexDirection: 'column' }} elevation={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Tabs value={tabIndex} onChange={ctrl.handleTabChange}>
                            <Tab label="Dados do Contrato" />
                            {ctrl.isEdit && <Tab label="Arquivos" />}
                        </Tabs>

                        {tabIndex === TAB_GENERAL && (
                            <Grid container spacing={3} sx={{ mt: 1 }}>
                                <ContractIdentificationSection errors={errors} onChange={ctrl.handleOnChange} onDateChange={ctrl.handleDateChange} />
                                <ContractSupplierSection request={contractRequest} errors={errors} onChange={ctrl.handleOnChange} />
                                <ContractValuesSection errors={errors} onChange={ctrl.handleOnChange} onFileChange={ctrl.setFileUpload} />
                            </Grid>
                        )}
                        {tabIndex === TAB_FILES && (
                            <Box sx={{ height: '600px', display: 'flex', flexDirection: 'column' }}>
                                <ContractFileDataTable contractId={contractId} />
                            </Box>
                        )}

                        <FormPageFooter onCancel={ctrl.navigateToList} onSave={ctrl.handleSave} isSaving={ctrl.isSaving} />
                    </LocalizationProvider>
                </Paper>
            </Grid>
        </React.Fragment>
    );
}
